import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    paddingLeft: theme.spacing(2)
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2)
  },
  bannerText: {
    fontWeight: theme.typography.fontWeightMedium,
    marginLeft: theme.spacing(1)
  },
  link: {
    textDecoration: 'none',
    marginLeft: theme.spacing(1),
    whiteSpace: 'nowrap'
  }
}));

export const useStickyHeaderStyles = makeStyles(theme => ({
  root: {
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(1)
  }
}));

export default useStyles;
